<template>
  <div>
    <!-- toasts message -->
          <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

<!-- <executionForm :formSchema="formSchema" v-on:emitCloseModal="close"></executionForm> -->

    <v-card-title>
      <h2> Execution List </h2>
      <v-spacer></v-spacer>
      <!-- <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field> -->
    </v-card-title>


      <!-- <td class="justify-center layout px-0">
        <div>
          <v-btn
            color="primary"
            dark
            slot="activator"
            class="mb-2"
            :to="`/procurement/executions`"
          >Search</v-btn>
        </div>
      </td> -->

<br>
      <div style="height:70vh !important" id="auto">
        <v-data-table
          v-bind:headers="headers"
          v-bind:items="items"
          v-bind:search="search"
          v-bind:pagination.sync="pagination"
          :total-items="totalItems"
          :loading="loading"
          class="elevation-1"
        >
        <template slot="items" slot-scope="props" >
          <td class="text-xs-left">{{ ++(props.index) }}</td>
          <td class="text-xs-left" @click="editItem(props.index, props.item)">
            <a> {{ props.item.package_no }} </a> <br>
            <span style="padding-right: 200px;"> {{ props.item.name }} </span>
          </td>
          <td class="text-xs-left">{{ props.item.contract_name }}</td>
          <td class="text-xs-left">
            <span v-if="props.item.status_id == 1" class="active">Plan</span>
            <span v-if="props.item.status_id == 2" class="in-active">Executed</span>
            <span v-if="props.item.status_id == 3" class="active">Revision</span>
            <span v-if="props.item.status_id == 4" class="in-active">Merge</span>
            <span v-if="props.item.status_id == 5" class="in-active">Split</span>
            <span v-if="props.item.status_id == 6" class="in-active">Close</span>
            <span v-if="props.item.status_id == 7" class="in-active">Cancel</span>
            <span v-if="props.item.status_id == 8" class="in-active">Procured</span>
            <span v-if="props.item.status_id == 9" class="in-active">In-Active</span>
          </td>
          <td class="text-xs-left">{{ props.item.from_date }}</td>
          <td class="text-xs-left" ><span style="padding-right: 200px;">
            {{ props.item.method_name + ' ( '+ props.item.market_approach + ' )' }}
          </span></td>
          <td class="text-xs-left">{{ props.item.type_name }}</td>
          <td class="text-xs-left">{{ props.item.unit_name }}</td>
          <td class="text-xs-left">{{ props.item.quantity }}</td>
          <td class="text-xs-left">{{ props.item.estimated_price | currency }}</td>
          
          
          
          <!-- v-if="props.item.is_execute == 0" 
          <td class="justify-center layout px-0">
            <v-btn
              
              color="primary"
              dark
              slot="activator"
              class="mb-2"
              @click="editItem(props.index, props.item)"
              
            >Execution</v-btn>
            <v-btn icon class="mx-0" v-if="props.item.is_execute == 1" @click="addDetails(props.item)" title="Detail">
                <v-icon color="teal">view_module</v-icon>
            </v-btn>
          </td> -->
        </template>


          <template slot="no-data" class="error">
          <div align="center"> No Data Found</div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");

//import executionForm from "./executionForm.vue";
import { preFix } from "../../../vuex/api";
import Axios from "axios";
import serverPath from '../../../server-path/server-path';
export default {
  // components: {
  //   executionForm
  // },

  data: () => ({
    dialog: false,
    totalItems: 0,
    loading: true,
    pagination: {
      sortBy: "id",
      descending: true
    },
    search: "",
    message:'',	
			snackbar: false,
			color: 'success',
			mode: '',
			timeout: 3000,
			left:'left',
    headers: [
      {
        text: "SL",
        align: "left",
        sortable: false,
        value: "id"
      },
      {
        text: "Package Number",
        align: "left",
        value: "package_number"
      },
      {
        text: "Contract Type",
        align: "left",
        value: "contract_name"
      },
      {
        text: "Status",
        align: "left",
        value: "status_id"
      },
      {
        text: "Start Date",
        align: "left",
        value: "start_date"
      },
      {
        text: "Method",
        align: "left",
        value: "method_name"
      },
      {
        text: "Procurement Type",
        align: "left",
        value: "type_name"
      },
      {
        text: "Unit",
        align: "left",
        value: "unit_name"
      },
      {
        text: "Quantity",
        align: "left",
        value: "quantity"
      },
      {
        text: "Estimated Price",
        align: "left",
        value: "estimated_price"
      },
      
    ],

    items: [],

    delete_id: "",
    row_index: "",
    confirmModel: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",

    leaveTypeModal: false,
    formSchema: {
      id: "",
      name: "",
      code: "",
      address: ""
    },
     SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    searchData:{
       package_id: sessionStorage.getItem('search_id'),
       search_start_date: sessionStorage.getItem('search_sdate'),
       search_end_date: sessionStorage.getItem('search_edate'),
    },
    queryData: {
      sortBy: "id",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      search_val: ""
    }
  }),

  created(){     
     if(this.searchData.package_id || (this.searchData.search_start_date && this.searchData.search_end_date)){
      this.getSearchData()
     }else{
       this.loadData()
     }
  },

  computed: {
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  mounted() {
    // this.loadData();
    this.SnackbarVal.color = "success";
      this.SnackbarVal.message = "Data Loading";
      this.SnackbarVal.snackbar = true;
  },

  methods: {
    addDetails(items)
    {
      sessionStorage.setItem("pacId", items.id); 
      sessionStorage.setItem("pacVersionId", items.package_versions_id); 
      this.$router.push('/procurement/execution-details');
    },
    
    loadData(pagination) {
      commonService.getAllData("proc_execution").then(res => {
        this.items = res.data;
        this.loading = false;
      });
    },

    editItem(index, item) {
      // this.formSchema = data;
      // this.leaveTypeModal = true;

      sessionStorage.setItem("pacId", item.id); 
      sessionStorage.setItem("pacVersionId", item.package_versions_id);

      this.row_index = index;
      this.formSchema = item;

      sessionStorage.setItem("package_info", item.id);      
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
      this.$router.push('/procurement/execution_form');
    },

    close(data) {
      this.leaveTypeModal = false;
      if (data.status == 1) {
        this.data = data;
        this.message = data.message
        this.snackbar = true;
        this.loadData();
      };
    },
    getSearchData(){
       let path = serverPath.serverPath
        
        let headers = {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('accessToken')
        }
       };
        Axios.post(path+'/api/proc_exec_search',this.searchData,headers)
         .then(res => {
            this.items = res.data.data;
            this.loading = false;
         })
         .catch(err => {
           console.log(err)
         })
    }
  }
};
</script>

<style scoped>

#auto{
  overflow-x: auto;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/procurement/execution/execution_data.vue